export const getValueFromLocalStorage = (key: string) => {
  if (typeof window !== "undefined" && window.localStorage) {
    const getValue = localStorage?.getItem(key) as string;
    try {
      return JSON.parse(getValue);
    } catch (error) {
      return null;
    }
  }
  return null;
};

export const setValueToLocalStorage = (key: string, value: string) => {
  return localStorage?.setItem(key, value);
};
